// Categories configuration matching the Expo app
export const CATEGORIES = [
  { 
    title: 'WFH', 
    icon: 'fa-house', 
    urlSlug: 'WFH', 
    displayName: 'WFH',
    value: 'WFH',  // Value stored in database
    meta: {
      title: 'WFH Jobs | Remote Work Opportunities | Fresher Job Adda',
      description: 'Find the best Work From Home (WFH) job opportunities. Browse remote work positions with flexible schedules and competitive salaries.',
      keywords: 'WFH jobs, remote work, work from home, remote jobs, telecommuting, virtual jobs, home office jobs'
    }
  },
  { 
    title: 'Internship', 
    icon: 'fa-graduation-cap', 
    urlSlug: 'internship', 
    displayName: 'Internship',
    value: 'Internship',
    meta: {
      title: 'Internship Jobs | Student Opportunities | Fresher Job Adda',
      description: 'Discover internship opportunities for students and recent graduates. Find paid and unpaid internships across various industries to kickstart your career.',
      keywords: 'internship jobs, student internships, graduate internships, paid internships, summer internships, career opportunities'
    }
  },
  { 
    title: 'Drive', 
    icon: 'fa-car', 
    urlSlug: 'drive', 
    displayName: 'Drive',
    value: 'Drive',
    meta: {
      title: 'Drive Jobs | Transportation Careers | Fresher Job Adda',
      description: 'Explore driving and transportation job opportunities. Find positions for drivers, delivery personnel, and transportation professionals.',
      keywords: 'drive jobs, driver positions, transportation jobs, delivery driver, truck driver, logistics jobs'
    }
  },
  { 
    title: 'Batches', 
    icon: 'fa-users', 
    urlSlug: 'batches', 
    displayName: 'Batches',
    value: 'Batches',
    meta: {
      title: 'Batch Jobs | Group Opportunities | Fresher Job Adda',
      description: 'Find batch job opportunities and group hiring positions. Discover roles for multiple candidates in the same company or project.',
      keywords: 'batch jobs, group hiring, multiple positions, team recruitment, bulk hiring, mass recruitment'
    }
  }
]; 

// Helper function to get meta information for a category
export const getCategoryMeta = (categorySlug) => {
  const category = CATEGORIES.find(cat => cat.urlSlug.toLowerCase() === categorySlug?.toLowerCase());
  return category?.meta || {
    title: 'Job Categories | Fresher Job Adda',
    description: 'Browse job opportunities across various categories. Find the perfect job that matches your skills and experience.',
    keywords: 'jobs, careers, employment, job search, job categories'
  };
}; 